import React from "react";
import { getUrl } from "../../helpers/Pipes";

export const Footer = ({ customClasses }) => {
  return (
    <footer className={["footer", customClasses].join(" ")}>
      <div className="container">
        <p className="copy">
          © Compass Banca S.p.A., Gruppo Bancario Monte dei Paschi di Siena iscritto all’Albo dei Gruppi Bancari al n. 1030, socio unico Mediobanca S.p.A. Direzione e Coordinamento Banca Monte dei Paschi di Siena S.p.A. Partita IVA Gruppo IVA Mediobanca: 10536040966; C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati - <a target={"_blank"} href={getUrl("datiSocietari")}>
              Dati Societari
            </a>


          {/* © Compass Banca S.p.A., socio unico direzione e coordinamento
          Mediobanca S.p.A., Tutti i diritti riservati -
          <span className="nowrap">
            Per i dati Societari{" "}
            <a target={"_blank"} href={getUrl("datiSocietari")}>
              clicca qui
            </a>
          </span> */}
        </p>
      </div>
    </footer>
  );
};
